import { DashboardStatsData } from "../interfaces/dashboard";

export const getFallbackStatsData = (): DashboardStatsData => ({
  balance: { current: 0, change: 0 },
  residents: { total: 0, change: 0 },
  staffs: { total: 0, change: 0 },
})